/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { DeleteV1UsersAddressesIdMutationResponse, DeleteV1UsersAddressesIdPathParams, DeleteV1UsersAddressesId422 } from "../../../types/DeleteV1UsersAddressesId.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getDeleteV1UsersAddressesIdUrlClient({ id }: { id: DeleteV1UsersAddressesIdPathParams["id"] }) {
  const res = { method: 'DELETE', url: `/v1/users/addresses/${id}` as const }
  return res
}

/**
 * @summary Delete address
 * {@link /v1/users/addresses/:id}
 */
export async function deleteV1UsersAddressesIdClient({ id }: { id: DeleteV1UsersAddressesIdPathParams["id"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteV1UsersAddressesIdMutationResponse, ResponseErrorConfig<DeleteV1UsersAddressesId422>, unknown>({ method : "DELETE", url : getDeleteV1UsersAddressesIdUrlClient({ id }).url.toString(), ... requestConfig })
  return res
}